import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-password-input',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './password-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordInputComponent {
  control = input<FormControl>(new FormControl<string>(''));
  label = input<string>('Contraseña')
  placeholder = input<string>(' ')
  showErrors = input<boolean>(false);
  formGroupError = input<boolean>(false);

  show = signal(false);
  type = computed<'text' | 'password'>(() => this.show() ? 'text' : 'password');

  showPassword() {
    this.show.update(v => !v);
  }
}
